const FIELD_REQUIRED = "This field is required";
const INVALID_EMAIL = "Invalid email address";
const INVALID_PHONE = "Invalid phone number";
const INVALID_LENGTH_OVER = (length: any) =>
  "Length can't exceed " + length + " characters";

export { INVALID_LENGTH_OVER, FIELD_REQUIRED, INVALID_EMAIL, INVALID_PHONE };
